<template>
    <admin-dashboard-layout>
         <v-card>
            <v-card-title>
                <div class="fill-width d-flex justify-space-between flex-wrap">
                    <div>
                        <v-list-item class="px-2">
                            <v-list-item-title>
                                {{ moderator.name }}
                            </v-list-item-title>
                        </v-list-item>
                    </div>
                    <div class="mr-2">
                        <v-btn text :to="{ name: 'admin.users.index' }"
                            >return</v-btn
                        >
                    </div>
                </div>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-row>
                        <v-col>
                            <v-text-field
                                :value="moderator.name"
                                disabled
                                label="Name"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                     <!-- <v-row>
                        <v-col>
                            <v-text-field
                                :value="moderator.status"
                                disabled
                                label="Status"
                            ></v-text-field>
                        </v-col>
                    </v-row> -->
                    <v-card-text>
                        <v-row dense>
                            <v-col sm="12" md="4">
                                <v-select
                                    label="Status"
                                    :items="statuses"
                                    item-text="text"
                                    item-value="value"
                                    v-model="status"
                                />
                            </v-col>
                            <v-col sm="12" md="4">
                                <v-btn
                                    class="btn-accent mt-4"
                                    @click="updateStatus()"
                                    text
                                >
                                    update status
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-col sm="12" md="4" v-if="status === 'rejected'">
                        <v-text-field
                            v-model="rejectionReason"
                            label="Rejection Reason"
                            required
                        ></v-text-field>
                    </v-col>
                </v-form>
            </v-card-text>
        </v-card>
    </admin-dashboard-layout>
</template>

<script>
import ModeratorRequests from "../../../models/admin/ModeratorRequest";
import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";

import { mapMutations } from "vuex";

export default {
    name: "moderator-requests-show",
    components: {
        // UserActions,
        AdminDashboardLayout,
    },
    data: function () {
        return {
            moderator: {},
            item: {},
            status: '',
            rejectionReason: '',
            statuses: [
                { text: 'Approve', value: 'accepted' },
                { text: 'Reject', value: 'rejected' },
            ]
        };
    },
    computed: {
        userId() {
            const id = this.$route.params.id;
            if (id === undefined) {
                return undefined;
            }
            return +id;
        },
    },    
    methods: {
        ...mapMutations(["showSnackBar"]),

        async loadUser() {
            this.moderator = await ModeratorRequests.find(this.userId);
            this.status = this.moderator.status;
        },

        async updateStatus() {
            const payload = { status: this.status };

            if (this.status === 'rejected') {
                payload.rejection_reason = this.rejectionReason;
            }
            ModeratorRequests.custom(this.moderator, "status")
                .config({ method: "PATCH", data: payload })
                .$get()
                .then(() => this.showSnackBar(this.$t("messages.success")))
                .catch(() => this.showSnackBar("Error"));
        },
    },
        async created() {
        await this.loadUser(this.userId);
    },
}
</script>
